<template>
  <section class="grid-flex">
    <section class="flex column w100">
      <div class="flex-1 flex row w100 middle">
        <div class="flex-1 w100">
          <div class="flex flex-1  middle">
            <div class="button primary" @click="openModalCreate()">
              Criar Funil
            </div>
            <div class="flex column" style="margin-left: 16px">
              Quantidade de funils: {{ account.used_limits.limit_shortlink | number }} / {{ account.plan_limits.limit_shortlink | number }}
              <div class="margin-top-s">Precisa de mais funils? <router-link :to="{ name: 'SubscriptionRedirect' }">Faça Upgrade</router-link></div>
            </div>
          </div>
        </div>
        <div class="flex-1 flex end filters-groupo-holder">
          <div v-if="false" class="flex between middle">
            <ltk-date-picker
            label="Filtro de data"
            v-model="filters.data.date"
            :loading="loading"
          ></ltk-date-picker>
          </div>
        </div>
      </div>
      <div class="flex w100 end">
        <div class="filters-groupo-holder">
          <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
          ></paginate>
        </div>
      </div>
      <div class="list-itens flex column w100">
        <div
          class="box flex-1 w100"
          v-for="(fun, index) in funnels"
          :key="index"
        >
        <div class="box-content">
          <div class="flex-1 w100">
            <div class="flex middle row">
              <div class="flex-3">
                <div class="flex middle row">
                  <div class="flex-1 name">
                    <p>
                      {{ fun.name }}
                    </p>
                  </div>
                </div>
              </div>
              <div class="action">
                <div class="flex end">
                  <router-link
                        :to="{
                          name: 'FunnelDetail',
                          params: { funnel_id: fun.id },
                        }"
                      >
                      
                    <div class="button primary">
                      Relatório
                    </div>
                  </router-link>
                  <router-link
                        :to="{
                          name: 'FunnelEdit',
                          params: { funnel_id: fun.id },
                        }"
                      >
                      
                    <div class="button secondary " style="margin-left: 8px">
                      EDITAR
                    </div>
                  </router-link>

                  <div
                    class="button secondary"
                    @click="openToDelete(fun)"
                    style="margin-left: 8px"
                  >
                    DELETAR
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div v-if="isEmpty" class="box flex w100">
        <div class="box-content">
          <p>
            Não encontramos nenhum funil criado. Crie seu primeiro funil para ter
            seus rastreamentos.
          </p>
        </div>
      </div>

      <div v-if="loading" class="flex w100">
        <content-loading>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
          <fake-line height="30"></fake-line>
        </content-loading>
      </div>

      <div class="flex-1 flex row w100 middle">
        <div class="flex w100 end filters-groupo-holder">
          <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
        </div>
      </div>
    </section>

    <!-- modal create / edit -->
    <modal
      :title="titleModal"
      :show="showModalCreateOrUpdate"
      @close="closeToEdit()"
    >
      <div class="content flex " slot="content">
        <div class="flex column w100">
          <form autocomplete="off" class="w100">
            <div class="flex-1 w100">
              <label>Nome</label>
              <input
                class="input"
                id="name"
                type="text"
                v-model="newFunnel.name"
                autocomplete="off"
              />
            </div>

          
          </form>
          <div class="flex w100 center margin-top-l">
            <div class="button primary" @click="saveOrUpdateFunnel()">
              {{isEdit ? 'SALVAR': 'CRIAR'}}
            </div>
          </div>
        </div>
      </div>
    </modal>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalDelete"
      description="Você tem certeza que deseja deletar esse Link?"
      @cancel="
        showModalDelete = false;
        selectedFunnelId = null;
      "
      @accept="deleteFunnel(selectedFunnelId.id)"
    ></modal-confirm>
  </section>
</template>

<script>
import moment from "moment";
moment.locale("pt-br");
import { mapState } from "vuex";
import Modal from "@/components/modal/Modal";
import ModalConfirm from "@/components/modal/ModalConfirm";

import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import {
  getFunnels,
  createFunnel,
  updateFunnel,
  deleteFunnel,
} from "@/services/funnel";

const EMPTY_FUNNEL = {
  name: "",
};

export default {
  name: "funnel",
  components: {
    Modal,
    ModalConfirm,
    ltkDatePicker,
  },
  data() {
    return {
      loading: false,
      loadingReport: false,
      showModalCreateOrUpdate: false,
      showModalDelete: false,
      selectedFunnelId: null,
      newFunnel: Object.assign({}, EMPTY_FUNNEL),
      funnels: [],
      reportfunnels: {},
      totalfunnels: 0,
      offset: 20,
      page: 1,
      filters: {
        data: {
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
        },
        list: {
        },
      },
      openUtmFields: false,
      opcoesIniciais: [
        'status = "ativo"',
        'idade > 18',
        'cidade = "São Paulo"',
        'tipo = "cliente"',
        'data_cadastro > "2023-01-01"'
      ],
      resultadoExpressao: null,
    };
  },
  mounted() {
    this.getFunnels();
    this.getFunnelsReport();
  },
  watch: {
    "filters.data": {
      deep: true,
      handler() {
        this.funnels = [];
        this.reportfunnels = {};
        this.getFunnels();
        this.getFunnelsReport();
      },
    },
    page: {
      handler() {
        this.funnels = [];
        this.getFunnels();
      },
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    titleModal() {
      return this.isEdit ? 'Editar Funil': 'Criar Funil'
    },
    isEmpty() {
      return this.totalfunnels === 0 && !this.loading;
    },
    isEdit() {
      if (this.newFunnel && this.newFunnel.id) {
        return true
      }
      return false
    },
    totalPages() {
      let valueMode = this.totalfunnels % this.offset;
      let value = this.totalfunnels / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    alertLimit() {
      if (this.account && this.account.plan_limits.limit_shortlink <= this.account.used_limits.limit_shortlink) {
        return true
      }

      return false
    },
  },
  methods: {
    processarExpressao(expressao) {
      console.log('Expressão lógica recebida:', expressao);
      this.resultadoExpressao = JSON.stringify(expressao, null, 2);
      // Aqui você pode fazer o que quiser com a expressão,
      // como enviar para uma API, armazenar no estado da aplicação, etc.
    },
    openModalCreate() {
      if(this.alertLimit) {
        this.$toast.error({
          title:'Erro',
          message:'Você já está usando o limite de links rastreaveis do seu plano! Faça upgrade para criar mais!'
        })

        return

      }
      
      this.showModalCreateOrUpdate = true
    },
    openToDelete(sl) {
      this.showModalDelete = true;
      this.selectedFunnelId = sl;
    },
    openToEdit(sl) {
      this.showModalCreateOrUpdate = true;
      this.newFunnel = sl;
    },
    closeToEdit() {
      this.showModalCreateOrUpdate = false;
      this.newFunnel = Object.assign({}, EMPTY_FUNNEL);
    },
    saveOrUpdateFunnel() {
      if (this.isEdit) {
        this.updateFunnel(this.newFunnel.id);
      } else {
        this.createFunnel();
      }
      this.closeToEdit();
    },
    getFunnels() {
      this.loading = true;

      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        page: this.page,
        offset: this.offset,
      };
      getFunnels(params)
        .then((result) => {
          this.funnels = result.funnels;
          this.totalfunnels = result.total;
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createFunnel() {
      let params = {
        name: this.newFunnel.name,
      };
      createFunnel(params)
        .then((result) => {
          this.funnels.push(result);
          this.totalfunnels = this.totalfunnels + 1

          this.$toast.success({
            title: "Sucesso",
            message: "Link criado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    updateFunnel(funnelId) {
      let params = {
        name: this.newFunnel.name,
      };

      updateFunnel(funnelId, params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Link editado com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        });
    },
    deleteFunnel(funnelId) {
      deleteFunnel(funnelId)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Link deletado com sucesso",
          });

          this.funnels = this.funnels.filter(e => e.id != funnelId)
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu algum problema",
          });
        })
        .finally(() => {
          this.selectedFunnelId = null;
          this.showModalDelete = false
        })
    },
  },
};

</script>

<style lang="scss" scoped>

.list-itens {
  .box + .box {
    margin-top: 8px;
    margin-left: 0px !important;
  }
}

.name {
  max-width: 400px;
  width: 400px;
  min-width: 400px;
  padding-right: 16px;
}

</style>
